import apiClient from "../api";

export const createSupplier = async (supplierData) => {
    try {
        const token = await localStorage.getItem('token');

        const response = await apiClient.post("gestock/suppliers/create", supplierData,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const deleteSupplier = async (supplierId, storeId) => {
    try {
        const response = await apiClient.delete(`gestock/suppliers/${supplierId}/${storeId}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};
